<div class="chat-input">
  <div class="chat-input__content" (dragover)="attachmentsService.onDragOver($event)" (drop)="onDrop($event)">
    <div class="chat-input__field">
      <textarea
        class="chat-input__textarea"
        [class.chat-input__textarea--expanded]="noHasConsent() && selectedChannel()?.routing === 'WHATSAPP'"
        rows="1"
        (paste)="onPaste($event)"
        (keyup.enter)="verifyMessage()"
        (keydown.enter)="onKeydown($event)"
        (change)="isSmartReplyOrAutoResponse = false"
        (input)="autoResizeTextArea()"
        spellcheck="true"
        placeholder="{{ 'NGX-MESSAGING.CHAT.typeHereYourText' | translate }}"
        minlength="1"
        [disabled]="noHasConsent()"
        [maxlength]="selectedWorkSpace()?.maxCharactersOnMessage ?? null"
        [ngModel]="text()"
        (ngModelChange)="text.set($event)"
        #myTextarea></textarea>
    </div>
    <div class="chat-input__options">
      @if (!noHasConsent()) {
      <button type="button" class="chat-input__icon-btn" (click)="openEmoji()">
        <mat-icon svgIcon="emoji"></mat-icon>
      </button>
      @if (!hideAttachments()) {
      <button
        type="button"
        class="chat-input__icon-btn"
        *hasChannelFeature="[ChannelFeatures.canSendAttachments]"
        (click)="uploader()!.nativeElement.click()">
        <input
          #imgupload
          type="file"
          [accept]="attachmentsService.allowedFileTypes"
          multiple
          (change)="onFilesSelected($event)"
          hidden />
        <mat-icon svgIcon="clip"></mat-icon>
      </button>
      <button
        type="button"
        class="chat-input__icon-btn"
        *hasChannelFeature="[ChannelFeatures.canUseGiphy]"
        (click)="giphyService.openGiphy()">
        <mat-icon svgIcon="gif"></mat-icon>
      </button>
      }
      <button
        type="button"
        class="chat-input__icon-btn chat-input__icon-btn--send"
        (click)="verifyMessage()"
        [disabled]="(!text().trim() && !attachments().length) || noHasConsent()">
        <mat-icon svgIcon="send"></mat-icon>
      </button>
      } @if (noHasConsent() && selectedChannel()?.routing === 'WHATSAPP') {
      <button type="button" (click)="reactivateChat()" class="chat-input__reactivate-message">
        {{ selectedChannel()?.messages?.length ? 'Reactivate chat' : 'Activate chat' }}
      </button>
      }
    </div>
  </div>
  @if (!hideAttachments()) {
  <ng-container *hasChannelFeature="[ChannelFeatures.canSendAttachments]">
    @if (attachments().length) {
    <ngx-attachments [attachments]="attachments()" (remove)="onRemoveAttachment($event)"> </ngx-attachments>
    }
  </ng-container>
  }
</div>
